<template>
  <v-dialog
    v-model="dialog"
    max-width="520"
    scrollable
    content-class="dialog-panoramica-mobile-info"
  >
    <v-card class="panoramica-mobile-info-card">
      <v-img
        class="panoramica-mobile-info-image"
        aspect-ratio="1.7777778"
        :src="promoPanoramicaImage"
      >
        <div class="panoramica-mobile-info-title-overlay">
          <div class="panoramica-mobile-info-title font-hemi-head">
            Visuale Panoramica
          </div>
        </div>
      </v-img>

      <v-card-text class="panoramica-mobile-info-content white--text pa-4">

        <v-alert dense text color="secondary" class="mt-3 mb-4">
          Disponibile solo da tablet o desktop.
        </v-alert>

        <div class="panoramica-mobile-info-browser">
          <div class="font-weight-bold font-italic mb-1">"Come possa fare ora?"</div>
          <div class="mb-2">
            Copia questo link su uno schermo più grande e potrai attivare la visuale 'Panoramica'.
          </div>

          <a
            class="panoramica-mobile-info-link secondary--text"
            :href="urlAsta"
            target="_blank"
          >
            {{ urlAsta }}
          </a>

          <div class="text-center mt-3">
            <v-btn color="secondary" rounded @click="copyUrl">
              <v-icon left small>content_copy</v-icon>
              Copia link
            </v-btn>
          </div>

          <div v-if="copyFeedback" class="panoramica-mobile-info-feedback">
            {{ copyFeedback }}
          </div>
        </div>
      </v-card-text>

      <v-card-actions class="justify-center pb-4">
        <v-btn color="secondary" outlined rounded class="font-hemi-head px-8" @click="dismiss">
          Ho capito
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import db from "../../js/db";
import Config from "../../../config-app/config";
import mixins from "../../js/mixins";

export default {
  name: "dialog-panoramica-mobile-info",
  mixins: [mixins],
  data() {
    return {
      dialog: false,
      copyFeedback: "",
    };
  },
  mounted() {
    console.log("--> DialogPanoramicaMobileInfo ready.");
    db.on("showPanoramicaMobileInfo", this.show);
  },
  destroyed() {
    console.log("<-- DialogPanoramicaMobileInfo destroyed.");
    db.off("showPanoramicaMobileInfo", this.show);
  },
  methods: {
    show() {
      this.copyFeedback = "";
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
    copyUrl() {
      navigator.clipboard
        .writeText(this.urlAsta)
        .then(() => {
          this.copyFeedback = "Link copiato";
        })
        .catch(() => {
          this.copyFeedback = "Non è stato possibile copiare il link";
        });
    },
  },
  computed: {
    promoPanoramicaImage() {
      return Config.FIREBASE_HOST + "/static/img/promo-panoramica.png";
    },
    urlAsta() {
      if (Config.STANDALONE) {
        return window.location.href;
      }

      return (
        Config.HOST + "/pages/asta-live/main.php?ID_Lega=" + this.asta_info.id
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.panoramica-mobile-info-card {
  background: var(--v-navy-darken2);
  color: var(--v-text-base);
  overflow: hidden;
}

.panoramica-mobile-info-image {
  background: var(--v-navy-darken3);
  max-height: 42vh;
  position: relative;
}

.panoramica-mobile-info-title-overlay {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  padding: 14px 16px 44px;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.68) 0%,
    rgba(0, 0, 0, 0.34) 56%,
    rgba(0, 0, 0, 0) 100%
  );
  pointer-events: none;
  z-index: 1;
}

.panoramica-mobile-info-title {
  color: white;
  font-size: 28px;
  line-height: 1.1;
  text-shadow: 0 3px 14px rgba(0, 0, 0, 0.75);
}

.panoramica-mobile-info-subtitle {
  font-size: 17px;
  line-height: 1.25;
}

.panoramica-mobile-info-browser {
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.18);
  padding: 12px;
}

.panoramica-mobile-info-link {
  display: block;
  word-break: break-all;
}

.panoramica-mobile-info-feedback {
  color: var(--v-secondary-base);
  font-size: 12px;
  margin-top: 8px;
  text-align: center;
}
</style>
